export default __webpack_public_path__ + "static/media/calendar-inactive-icon-dark.01c1c05c.svg";